import Header from "./Header";
import Footer from "./footer";
// import { Carousel } from 'react-responsive-carousel';
import Slider from "react-slick";
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Post,
  LoginURL,
  forgotPassword,
  loginWithOtp,
  homeURL,
  image_url,
  AddToCartURL,
} from "../utils/api";
import { useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { wrapComponent } from "react-snackbar-alert";
import { useSelector } from "react-redux";
import CartModal from "../component/cartModal";

var settings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrow: true,
  slidesToShow: 3,
  autoplay: true,
  slidesToScroll: 1,
};
var settings1 = {
  dots: true,
  infinite: true,
  autoplay: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: true,
  className: "variable-width"
};

var settings3 = {
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 1000,
  slidesToShow: 5,
  slidesToScroll: 2,
};

const Home = ({ createSnackbar }) => {
  const [refres, setrefres] = useState(false);
  const navigate = useNavigate();
  const [state, setState] = useState({
    featured_pro: [],
    ingredients: [],
  });

  const stateHandler = (key, value) => {
    state[key] = value;
    setState({ ...state });
  };

  useEffect(() => {
    fetchHomeItems();
  }, []);

  const fetchHomeItems = () => {
    global.Loader(true);
    let config = {
      url: homeURL,
    };
    Post(config)
      .then((res) => {
        global.Loader(false);
        if (res.status == true) {
          setState({
            ingredients: res?.ingredients,
            videotestimonial: res?.videotestimonial,
            featured_pro: res?.featured_pro,
          });
        }
      })
      .catch((err) => {
        global.Loader(false);
        console.log(err);
      });
  };

  const getSliderLenght = (item, min) => {
    if (item?.length > min) {
      return item?.length;
    } else {
      return min;
    }
  };

  const getSliderItem = (item, min) => {
    if (item?.length > min) {
      return item;
    } else {
      return [...item, ...item];
    }
  };
  const showSnack = (msg = "", type = "error") => {
    createSnackbar({
      message: msg,
      theme: type,
    });
  };

  const { cartItems, userinfo } = useSelector((state) => state);

  const addToCart = ({ qnty = 1, id, varient_id }) => {
    console.log(varient_id);
    if (userinfo?.token) {
      if (varient_id) {
        global.Loader(true);
        let config = {
          body: {
            product_id: id,
            variant_id: varient_id,
            quantity: qnty,
          },
          url: AddToCartURL,
        };
        Post(config)
          .then((res) => {
            global.Loader(false);
            if (res.status == true) {
              showSnack(res?.msg, "success");
              setrefres(!refres);
              let index = cartItems?.findIndex((v) => v.product_id == id);
              if (index == -1) {
                global.dispatch({
                  type: "CARTITEMS",
                  payload: [...cartItems, { product_id: id }],
                });
              }
            }
          })
          .catch((err) => {
            global.Loader(false);
            console.log(err?.response?.data);
          });
      } else {
        showSnack("Please Select Varient");
      }
    } else {
      showSnack("Please Login");
      navigate("/login");
    }
  };

  //console.log(addToCart);
  const getEmbeded = (url) => {
    if (url) {
      let data = url.split("?v=");
      if (data?.length == 2) {
        data = data[1].split("&");
        return `https://www.youtube.com/embed/${data[0]}`;
      }
    } else {
      return "";
    }
  };

  const getRating = (value) => {
    let Array = [];
    let lasti = 1;
    for (let i = 1; i < 6; i++) {
      if (value >= i) {
        Array.push(1);
      } else {
        Array.push(0);
      }
    }
    return Array;
  };

  const truncate = (value, tunc = 20) => {
    if (value) {
      return `${value.substr(0, tunc)}`;
    } else {
      return "";
    }
  };
  const selectVarient = ({ id, product_weight, product_id }) => {


    let list = [...state.featured_pro];
    const index = list?.findIndex((v) => v.id == product_id);
    if (index != -1) {
      list[index]["varient_id"] = id;
      list[index]["product_weight"] = product_weight;
    }
    stateHandler("featured_pro", list);
  };

  return (
    <div>
      <Header
        cartClick={() => {
          setrefres(!refres);
        }}
      />
      <div className="large">
        <div className="container">
          <div
            className="clock"
            onClick={() => {
              navigate("/shoppage");
            }}
          >
            {/* <!-- <span className="ipsum"><i className="fa-solid fa-left-long"></i></span> --> */}
            <h4>
              Shop Now <img src="/images/Vector2.png" alt="" />
            </h4>
          </div>
          <div className="enriched">
            <div className="supp">
              <h1>Nature enriched supplements</h1>
            </div>
            <div className="high">
              <img src="/images/img1.png" alt="" />
              <img src="/images/img2.png" alt="" />
              <img src="/images/img3.png" alt="" />
              <img src="/images/img4.png" alt="" />
              <img src="/images/img5.png" alt="" />
              <img src="/images/img6.png" alt="" />
              <p>
                Naturally extracted goodness backed by Ancient Ayurveda & Modern
                Science.{" "}
              </p>
            </div>
            <div className="taare">
              <img src="/images/background1.png" alt="" />
              <h3>Our Ingredients</h3>
            </div>
            <div style={{ marginBottom: "100px" }}>
              {state?.ingredients && (
                <Slider
                  {...settings}
                  slidesToShow={getSliderLenght(state?.ingredients, 3)}
                >
                  {getSliderItem(state?.ingredients, 4).map((value, index) => (
                    <div key={`indgrents_${index}`} className="item1">
                      <div className="">
                        <div
                          className="ORANGE"
                          style={{ width: "70%", "marginTop": "15%" }}
                        >
                          <div
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                              display: "flex",
                              marginTop: "-10%",
                            }}
                          >
                            <img
                              onClick={() => navigate(`Ingredient/${value.id}`)}
                              src={`${image_url}${value?.image}`}
                              alt=""
                              style={{
                                width: "100%",
                                marginTop: "-30%",
                                marginBottom: "-18%",
                              }}
                            />
                          </div>
                          <h3>{value?.title}</h3>
                          <p>{value.description}</p>
                          <a
                            className="details-btn"
                            onClick={() => navigate(`Ingredient/${value.id}`)}
                          >
                            VIEW PRODUCTS
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              )}
            </div>
            <div
              onClick={() => {
                navigate("/ingredents");
              }}
              className="view_products"
            >
              <a>
                View all <img src="/images/Vector2.png" alt="" />
              </a>
            </div>
            <div className="press press_media certification">
              <h1 className="videotesti">Licenses & Certifications</h1>
              <div style={{ marginBottom: "100px" }}>
                <Slider {...settings1}>
                  <div className="items1">
                    <img src="/images/AYUSH GMP.png" alt="" />
                  </div>

                  <div className="items1">
                    <img src="/images/DSIR_ZIVA.png" alt="" />
                  </div>
                  <div className="items1">
                    <img src="/images/AYUSH.png" alt="" />
                  </div>
                  <div className="items1">
                    <img src="/images/DUNS & BRADSHEETZIVA.png" alt="" />
                  </div>
                  <div className="items1">
                    <img src="/images/FDA REGISTERED.png" alt="" />
                  </div>
                  <div className="items1">
                    <img src="/images/FSSAI.png" alt="" />
                  </div>

                  <div className="items1">
                    <img src="/images/halal india.png" alt="" />
                  </div>
                </Slider>
              </div>
            </div>
            <div className="featured">
              <h1 className="featuredh1">
                Featured <br />
                Products
              </h1>
              <div className="over">
                <div className="women_man">
                  <img
                    src="/images/aaa.png"
                    style={{ marginLeft: "-10%" }}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="full"></div>
            <div className="here">
              <div className="row">
                {state?.featured_pro?.map((item, index) => {
                  let benifies = item?.product_benefit?.slice(0, 3);
                  return (
                    <div className="col-md-4" key={`featurepro_${index}`}>
                      <div
                        className="sign_of"
                       // onClick={() => navigate(`/shop/${item.id}`)}
                      >
                        <div className="row">
                          <div className="col-md-6">
                            <div className="setting">
                              <img
                                src={`${image_url}${item?.image}`}
                                style={{ width: "100%" }}
                                alt="" onClick={() => navigate(`/shop/${item.id}`)}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="active_women">
                              <h5 className="product-name" onClick={() => navigate(`/shop/${item.id}`)}>{truncate(item?.title)}</h5>
                              <div className="icon-star star_icon">
                                {getRating(item.avg_rating)?.map((v, i) =>
                                  v == 1 ? (
                                    <i className="fa-solid fa-star"></i>
                                  ) : (
                                    <i className="fa-regular fa-star"></i>
                                  )
                                )}
                                {/* <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-regular fa-star"></i> */}
                                <p>{item.no_of_review}</p>
                              </div>
                              <div>
                                {/*<select
                                  className="selector"
                                  style={{ width: "137px" }}
                                >
                                 <option value="">Select</option>
                                  {item?.item_variations?.map((v2, i) => (
                                    <option
                                     
                                      onClick={() => {
                                        selectVarient(v2);
                                      }}
                                    >
                                      <p>
                                        {console.log(v2, v2.product_weight)}
                                        {v2?.product_weight}{" "}
                                        <i className="fa-solid fa-chevron-down"></i>
                                      </p>
                                    </option>
                                  ))}
                                </select>*/}

                                <select
                                  className="selector"
                                  style={{ width: "137px" }}
                                  onChange={(event) => {
                                    const selectedVariantId = event.target.value; // Get the selected value
                                    const selectedVariant = item?.item_variations?.find(
                                      (v2) => v2.product_weight === selectedVariantId
                                    );
                                    if (selectedVariant) {
                                      selectVarient(selectedVariant); // Call the selectVarient function with the selected variant
                                    }
                                  }}
                                >
                                  <option value="">Select</option>
                                  {item?.item_variations?.map((v2, i) => (
                                    <option key={i} value={v2.product_weight}>
                                      {v2?.product_weight}
                                    </option>
                                  ))}
                                </select>

                              </div>
                              {/* <div className="powder">
                                                    <p>200g x 1 Pkt |<i className="fa-solid fa-chevron-down"></i><br/> Orange mix
                                                    </p>
                                                </div> */}
                              <div className="ingr">
                                <h3>₹{item?.price}&nbsp;&nbsp;<span  style={{
                                textDecoration: "line-through",
                                fontWeight: "500"
                              }}>800</span></h3>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="repair">
                          <div className="repairC">
                            <p
                              style={{
                                overflow: "hidden",
                                maxHeight: "90px",
                                minHeight: "90px",
                                marginBottom: "0px",
                                minHeight: "80px",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            ></p>
                          </div>
                          <div
                            className="iconpad1"
                            style={{ minHeight: "132px" }}
                          >
                            {benifies?.map((v3, i) => (
                              <p>
                                <img
                                  src={`${image_url}${v3?.icon}`}
                                  style={{
                                    height: "30px",
                                    width: "30px",
                                    marginRight: "10px",
                                  }}
                                />{" "}
                                {truncate(v3?.point, 35)}
                              </p>
                            ))}
                          </div>
                          <div className="cough">
                            <button
                              onClick={() => {
                                addToCart(item);
                              }}
                              
                            >
                              Add to cart (₹{item?.price})
                            </button>
                            <p>Free 7-10 days delivery across India</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="more">
                <p>
                  Looking for something more specific? Check out our complete
                  range of products{" "}
                </p>
                <button
                  onClick={() => {
                    navigate("/shoppage");
                  }}
                >
                  Explore Shop
                </button>
              </div>
            </div>
            <div
              style={{ marginBottom: "80px", marginTop: "60px" }}
              className="press press_media"
            >
              <h1 className="videotesti">Press & Media</h1>
              <Slider {...settings3}>
                <div className="items1">
                  <img src="/images/Paytm6.png" alt="" />
                </div>
                <div className="items1">
                  <img src="/images/Paytm (1).png" alt="" />
                </div>
                <div className="items1">
                  <img src="/images/ET-healthworld.png" alt="" />
                </div>
                <div className="items1">
                  <img src="/images/Paytm (3).png" alt="" />
                </div>

                <div className="items1">
                  <img src="/images/Paytm6.png" alt="" />
                </div>
                <div className="items1">
                  <img src="/images/Paytm (1).png" alt="" />
                </div>
                <div className="items1">
                  <img src="/images/ET-healthworld.png" alt="" />
                </div>
                <div className="items1">
                  <img src="/images/Paytm (3).png" alt="" />
                </div>
              </Slider>
            </div>
            <div
              style={{ marginBottom: "80px", marginTop: "80px" }}
              className="press_test"
            >
              <h1 className="videotesti">Video Testimonials</h1>
              <Slider {...settings}>
                {state?.videotestimonial?.map((value, index) => (
                  <div className="item1">
                    <iframe
                      width="410px"
                      height="200"
                      src={getEmbeded(value.url)}
                    ></iframe>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          <div className="overlay"></div>
        </div>
      </div>
      <div className="speci">
        <div className="icon1">
          <div className="facebook">
            {" "}
            <i className="fa-brands fa-facebook-f"></i>
          </div>
          <div className="twitter">
            <i className="fa-brands fa-twitter"></i>
          </div>
          <div className="instagram">
            <i className="fa-brands fa-instagram"></i>
          </div>
          <div className="pinterest">
            <i className="fa-brands fa-pinterest-p"></i>
          </div>
          <div className="youtube">
            <i className="fa-brands fa-youtube"></i>
          </div>
          <div className="linkedin">
            <i className="fa-brands fa-linkedin-in"></i>
          </div>
        </div>
      </div>

      <CartModal refres={refres} show={true} />
      <Footer />
    </div>
  );
};

export default wrapComponent(Home);
